import fpaPermanent from "@/components/common/i18n/fpaManage/fpaPermanent";
import DQMP from "@/router/DQMP";
import QBR from "@/router/QBR";

//需要进行查询条件保存的模块路由名称
export let queryName = [
    "apply",
    "quotation",
    "applySp",
    "quotationSp",
    "feedback",
    "feedbackReport",
    "visitPlan",
    "visitReportList",
    "visitReportSp",
    "sensoryTemplate",
    "sensoryReportList",
    "sensoryCalibration",
    "material",
    "linePriceData",
    "materialPriceData",
    "sourcing",
    "productQuotationApplication",
    "productQuotationApplicationSp",
    "inquiryQuotationProduct",
    "inquiryQuotationProductSp",
    "sourcingByProduct",
    "fpaPermanentList",
    "fpaLtoCampaignList",
    "fpaLtoList",
    "materialMasterData",
    "qbr",
    "qbrPlan",
    "dqmp",
    "SWA",
    "SQMS",
    "govtCert",
    "specCompliance",
    "COA",
    "regCompliance",
    "govtPlantAudit",
    "stockRecovery",
    "productFeedback",
    "sensory",
    "MSV",
    "stockRecoveryPage",
    "QIP",
    "fspi",
    "rmcProtAudit",
    "rmcProtFeedPlant",
    "rmcProtFarm",
    "rmcProdFarm",
    "rmcProdAudit",
    "rmcProtPurchase",
    "rmcProdPurchase",
    "griNutritionAnalysis",
];
//从查询页面跳转到相应的页面路由的名称
export let detailName = [
    "applyDetail",
    "sourcingDetail",
    "quotationDetail",
    "quotationHistory",
    "applySpDetail",
    "quotationSpDetail",
    "quotationSpHistory",
    "feedbackDetail",
    "feedbackReportView",
    "feedbackReportAudit",
    "visitPlanAdd",
    "visitReport",
    "visitReportSpDetail",
    "addTemplate",
    "sensoryReportDetail",
    "newSensoryReport",
    "newSensoryCalibration",
    "sensoryCalibrationDetail",
    "materialDetail",
    "linePriceDetail",
    "materialPriceHistory",
    "sourcingDetail",
    "productQuotationApplicationAdd",
    "productQuotationApplicationAdd",
    "inquiryQuotationProductDetail",
    "inquiryQuotationProductDetailsp",
    "sourcingByProductDetail",
    "inquiryQuotationProductsphistory",
    "fpaPermanentDetail",
    "fpaLtoCampaignDetail",
    "fpaLtoDetail",
    "materialMasterAdd",
    "qbrDetail",
    "qbrPlanDetail",
    "dqmpDetail",
    "qspiOtherDetail",
    "stockRecoveryPageDetail",
    "QIPDetail",
    "fspiDetail",
    "rmcProtAuditDetail",
    "rmcProtFeedplantDetail",
    "rmcProtFeedplantAuditDetail",
    "rmcProtFarmDetail",
    "rmcProdFarmDetail",
    "rmcProdAuditDetail",
    "rmcProtPurchaseDetail",
    "rmcProdPurchaseDetail",
    "nutritionAnalysisDetail",
];
//产品报价确认查询条件
export let sourcingByProductQueryParam = {
    pageSize: 15, //每页多少条
    isSpecialFreight: null,
    sourcingNo: null,
    applyNo: null,
    subject: null,
    isSpecialFreight: null,
    tmSupplierId: null,
    createBy: null,
    creater: null,
    auditor: "",
    auditDateStart: null,
    auditDateEnd: null,
    dateFrom: "",
    dateTo: "",
    eightBitCodesStr: null,
    eightBitCodes: [],
};
//物料主数据查询条件
export let inquiryQuotationProductSpQueryParam = {
    pageSize: 15,
    pageNum: 1,
    applyNo: null,
    subject: null,
    supplierCode: null,
    roundNumber: null,
    roundStatus: null,
    buyerName: null,
    createDate: null,
    createEndDate: null,
};
//物料主数据查询条件
export let materialQueryParam = {
    pageSize: 15,
    pageNum: 1,
    eightBitCode: null,
    eightBitCodeName: null,
    plantNo: null,
    plantName: null,
    supplierCode: null,
    supplierName: null,
    pickupPoint: null,
    dcName: null,
    temperature: null,
    transportaionMethod: null,
};
//线路报价主数据查询条件
export let linePriceDataQueryParam = {
    pageSize: 15,
    pageNum: 1,
    pickupPoint: "",
    temperature: "",
    tmDcId: "",
    transportaionMethod: "",
    unit: "",
    tcCurrencyId: "",
    beginDate: "",
    endDate: "",
    tmSupplierId: "",
};
//物料运费价格主数据查询条件
export let materialPriceDataQueryParam = {
    eightBitCode: null,
    eightBitCodeName: null,
    tmPickupId: null,
    tmDcId: null,
    temperature: null,
    transportaionMethod: null,
    lineSupplierId: null,
    isSpecialFreight: null,
    pageNum: 1,
    pageSize: 15,
};
//线路申请单基本查询条件(MCD)
export let applyQueryParam = {
    pageSize: 15,
    pageNum: 1,
    applyNo: null,
    applyType: null,
    subject: null,
    sourcingNo: null,
    supplierCode: null,
    quotationType: null,
    quotationStatus: null,
    sourcingStatus: null,
    status: null,
    buyerName: null,
    createDate: null,
    createEndDate: null,
    tmSupplierId: null,
};
//线路报价单基本查询条件(MCD)/询报价(线路)查询条件
export let quotationQueryParam = {
    pageSize: 15,
    pageNum: 1,
    applyNo: null,
    applyType: null,
    subject: null,
    quotationType: null,
    supplierCode: null,
    roundNumber: null,
    buyerName: null,
    createDate: null,
    createEndDate: null,
    roundStatus: null,
    tmSupplierId: null,
};
//线路申请单基本查询条件(Supplier)
export let applySpQueryParam = {
    pageSize: 15,
    pageNum: 1,
    applyNo: null,
    applyType: null,
    subject: null,
    supplierCode: null,
    quotationType: null,
    status: null,
    buyerName: null,
    createDate: null,
    createEndDate: null,
};
//线路报价单基本查询条件(Supplier)
export let quotationSpQueryParam = {
    pageSize: 15,
    pageNum: 1,
    applyNo: null,
    applyType: null,
    subject: null,
    quotationType: null,
    supplierCode: null,
    roundNumber: null,
    buyerName: null,
    createDate: null,
    roundStatus: null,
};
//线路报价确认查询条件
export let sourcingQueryParam = {
    pageSize: 15,
    pageNum: 1,
    sourcingNo: "",
    subject: "",
    auditor: "",
    applyType: "",
    quotationType: "",
    createUserName: "",
    createDateStart: "",
    createDateEnd: "",
    auditDateStart: "",
    auditDateEnd: "",
    createDateArr: null,
    supplierCode: "",
    tmSupplierIds: [],
    applyNo: "",
    status: "",
};
//产品报价申请单查询条件
export let productQuotationApplicationQueryParam = {
    pageSize: 15,
    pageNum: 1,
    applyNo: null,
    subject: null,
    applyType: null,
    supplierCode: null,
    status: null,
    quotationStatus: null,
    name: null,
    sourcingNo: null,
    sourcingStatus: null,
    createDate: null,
    createEndDate: null,
    tmSupplierId: null,
    eightBitCodes: [],
    eightBitCodesStr: null,
};
//产品报价申请单查询条件(SP)
export let productQuotationApplicationSpQueryParam = {
    pageSize: 15,
    pageNum: 1,
    applyNo: null,
    subject: null,
    applyType: null,
    supplierCode: null,
    name: null,
    createDate: null,
    createEndDate: null,
    eightBitCodesStr: null,
    eightBitCodes: [],
};
//询报价(产品)
export let inquiryQuotationProductQueryParam = {
    pageSize: 15,
    pageNum: 1,
    applyNo: null,
    subject: null,
    supplierName: null,
    roundNumber: null,
    roundStatus: null,
    buyerName: null,
    createDate: null,
    createEndDate: null,
    tmSupplierId: null,
    eightBitCodesStr: null,
    eightBitCodes: [],
};
// 询报价产品(sp)
export let inquiryQuotationProductQueryParamSP = {
    pageSize: 15,
    pageNum: 1,
    applyNo: null,
    subject: null,
    supplierCode: null,
    roundNumber: null,
    roundStatus: null,
    buyerName: null,
    createDate: null,
    createEndDate: null,
    eightBitCodesStr: null,
    eightBitCodes: [],
};
//问题报告 查询条件
export let feedbackQueryParam = {
    pageNum: 1, //当前页
    pageSize: 15, //每页多少条
    feedbackNo: null,
    storeNo: null,
    storeName: null,
    createName: null,
    dcName: null,
    supplierName: null,
    supplierCode: null,
    materialCode: null,
    materialName: null,
    sourceCode: null,
    consumeType: null,
    isDirectSale: null,
    processNode: null,
    querySupplierId: null,
    auditor: "",
    categoryLevel1Code: null,
    categoryLevel2Code: null,
    createDateFrom: "",
    createDateTo: "",
    commitDateFrom: "",
    commitDateTo: "",
};

//调查报告 查询条件
export let feedbackReportQueryParam = {
    reportNo: null,
    from: "report", //调查报告查询列表
    feedbackNo: null,
    storeNo: null,
    storeName: null,
    creator: null,
    tmDcId: null,
    tmSupplierId: null,
    materialCode: null,
    materialName: null,
    sourceCode: null,
    consumeType: null,
    isDirectSale: null,
    statusList: ["lowerHair"],
    pageNum: 1,
    pageSize: 15,
    storeCostTimeFrom: "",
    supplierCostTimeFrom: "",
    fbccostTimeFrom: "",
    cqscostTimeFrom: "",
    storeCostTimeTo: "",
    supplierCostTimeTo: "",
    fbccostTimeTo: "",
    cqscostTimeTo: "",
    auditor: "",
    categoryLevel1Code: null,
    categoryLevel2Code: null,
    createDateFrom: "",
    createDateTo: "",
    commitDateFrom: "",
    commitDateTo: "",
};
//年度拜访计划查询条件
export let visitPlanQueryParam = {
    category: "",
    riskLevel: "",
    pageSize: 15,
    pageNum: 1,
    msv: {
        msvNo: "",
        year: "",
        status: "",
    },
    responsibleCqs: "",
    creater: "",
    supplierCode: "",
    supplierName: "",
    monthStatus: "",
    type: "",
    remark: "",
    dataArr: [],
};
//拜访报告查询条件
export let visitReportListQueryParam = {
    pageSize: 15,
    pageNum: 1,
    creater: "",
    year: "",
    supplierCode: "",
    supplierName: "",
    category: "",
    msvNo: "",
    status: "",
    type: "",
    dataArr: [],
    dataArr2: [],
};
//拜访报告查询条件(SP)
export let visitReportSpQueryParam = {
    msvNo: "",
    status: "",
    pageSize: 15,
    pageNum: 1,
    year: "",
    supplierCode: "",
    category: "",
    type: "",
    creater: "",
    tmSupplierIds: [],
    supplierName: "",
    dataArr: [],
    dataArr2: [],
};
//品评报告模板
export let sensoryTemplateQueryParam = {
    pageSize: 15,
    pageNum: 1,
    templateNo: "",
    templateName: "",
    status: "",
};
//品评报告
export let sensoryReportListQueryParam = {
    pageSize: 15,
    pageNum: 1,
    rater: "",
    reportNo: "",
    fiveBitCodeName: "",
    plantName: "",
    remark: "",
    rateType: "",
    sampleSource: "",
    status: "",
    rateDateArr: [],
};
//品评人员校准
export let sensoryCalibrationQueryParam = {
    pageSize: 15,
    pageNum: 1,
    serialNo: null,
    fiveBitCodeName: null,
    fiveBitCode: null,
    rateType: null,
    rateDateBegin: null,
    rateDateEnd: null,
    status: null,
    plantIds: null,
    remark: null,
    rateDateArr: [],
};
// fpaPermanent
export let fpaPermanentListQueryParam = {
    queryType: "fpaPermanent",
    pageSize: 15,
    pageNum: 1,
    fpaNo: "",
    fpaName: "",
    startDate: "",
    endDate: "",
    supplierCode: "",
    supplierAbbreviation: "",
    createUser: "",
    status: "",
    category1: null,
    category2: null,
    materialNo: "",
    sourceType: null,
};
export let fpaLtoCampaignListQueryParam = {
    pageSize: 15,
    pageNum: 1,
    fpaNo: "",
    fpaName: "",
    startDate: "",
    endDate: "",
    supplierCode: "",
    supplierAbbreviation: "",
    materialNo: "",
    createUser: "",
    status: "",
};
// fpaLtoList
export let fpaLtoListQueryParam = {
    pageSize: 15,
    pageNum: 1,
    fpaNo: "",
    fpaName: "",
    startDate: "",
    endDate: "",
    createUser: "",
    status: "",
    materialNo: "",
};
// 物料主数据维护
export let materialMasterDataQueryParam = {
    pageSize: 15,
    pageNum: 1,
    fiveBitCode: null,
    eightBitCodeList: [],
    eightBitCodeStr: "",
    eightBitCodeList: null,
    eightBitCodeName: null,
    dummyCode: null,
    settlementUnitName: null,
    settlementUnitCode: null,
    categoryLevel1Id: null,
    categoryLevel2Id: null,
    categoryLevel3Id: null,
    status: null,
    conductStatus: null,
    startCreateDate: null,
    endCreateDate: null,
    isUrgentMaterial: null,
};
// QBR
export let qbrQueryParam = {
    category2CodesList: [],
    monthList: [],
    groupName: "",
    planStatus: "",
    qbrStatus: "",
    pageNum: 1,
    pageSize: 15,
};
// QBR计划
export let qbrPlanQueryParam = {
    year: "",
    category2CodesList: [],
    category3CodesList: [],
    groupName: "",
    monthList: [],
    planStatus: "",
    pageNum: 1,
    pageSize: 15,
};
// DQMP
export let dqmpQueryParam = {
    monthList: [],
    dcName: "",
    isFile: "",
    status: "",
    pageNum: 1,
    pageSize: 15,
};
// SWA
export let SWAQueryParam = {
    monthList: [], //评价月
    category2CodeList: [], //category2Code集合
    category3CodeList: [], //category3Code集合
    groupName: "", //供应商集团名称
    facilityName: "", //facility名称
    factorType: "SWA", //指标类型
    status: "", //状态
    grade: "", //等级
    isExistDocument: "", //是否显示有附件的数据
    pageNum: 1,
    pageSize: 15,
};
// SQMS
export let SQMSQueryParam = {
    monthList: [], //评价月
    category2CodeList: [], //category2Code集合
    category3CodeList: [], //category3Code集合
    groupName: "", //供应商集团名称
    facilityName: "", //facility名称
    factorType: "SQMS", //指标类型
    status: "", //状态
    grade: "", //等级
    isExistDocument: "", //是否显示有附件的数据
    pageNum: 1,
    pageSize: 15,
};
// govtCert
export let govtCertQueryParam = {
    monthList: [], //评价月
    category2CodeList: [], //category2Code集合
    category3CodeList: [], //category3Code集合
    groupName: "", //供应商集团名称
    facilityName: "", //facility名称
    factorType: "GOVT_CERT", //指标类型
    status: "", //状态
    grade: "", //等级
    isExistDocument: "", //是否显示有附件的数据
    pageNum: 1,
    pageSize: 15,
};
// specCompliance
export let specComplianceQueryParam = {
    monthList: [], //评价月
    category2CodeList: [], //category2Code集合
    category3CodeList: [], //category3Code集合
    groupName: "", //供应商集团名称
    facilityName: "", //facility名称
    factorType: "SPEC_COMPLIANCE", //指标类型
    status: "", //状态
    grade: "", //等级
    isExistDocument: "", //是否显示有附件的数据
    pageNum: 1,
    pageSize: 15,
};
// COA
export let COAQueryParam = {
    monthList: [], //评价月
    category2CodeList: [], //category2Code集合
    category3CodeList: [], //category3Code集合
    groupName: "", //供应商集团名称
    facilityName: "", //facility名称
    factorType: "COA", //指标类型
    status: "", //状态
    grade: "", //等级
    isExistDocument: "", //是否显示有附件的数据
    pageNum: 1,
    pageSize: 15,
};
// regCompliance
export let regComplianceQueryParam = {
    monthList: [], //评价月
    category2CodeList: [], //category2Code集合
    category3CodeList: [], //category3Code集合
    groupName: "", //供应商集团名称
    facilityName: "", //facility名称
    factorType: "REG_COMPLIANCE", //指标类型
    status: "", //状态
    grade: "", //等级
    isExistDocument: "", //是否显示有附件的数据
    pageNum: 1,
    pageSize: 15,
};
// govtPlantAudit
export let govtPlantAuditQueryParam = {
    monthList: [], //评价月
    category2CodeList: [], //category2Code集合
    category3CodeList: [], //category3Code集合
    groupName: "", //供应商集团名称
    facilityName: "", //facility名称
    factorType: "GOVT_PLANT_AUDIT", //指标类型
    status: "", //状态
    grade: "", //等级
    isExistDocument: "", //是否显示有附件的数据
    pageNum: 1,
    pageSize: 15,
};
// stockRecovery
export let stockRecoveryQueryParam = {
    monthList: [], //评价月
    category2CodeList: [], //category2Code集合
    category3CodeList: [], //category3Code集合
    groupName: "", //供应商集团名称
    facilityName: "", //facility名称
    factorType: "STOCK_RECOVERY", //指标类型
    status: "", //状态
    grade: "", //等级
    isExistDocument: "", //是否显示有附件的数据
    pageNum: 1,
    pageSize: 15,
};
// productFeedback
export let productFeedbackQueryParam = {
    monthList: [], //评价月
    category2CodeList: [], //category2Code集合
    category3CodeList: [], //category3Code集合
    groupName: "", //供应商集团名称
    facilityName: "", //facility名称
    factorType: "PRODUCT_FEEDBACK", //指标类型
    status: "", //状态
    grade: "", //等级
    isExistDocument: "", //是否显示有附件的数据
    pageNum: 1,
    pageSize: 15,
};
// sensory
export let sensoryQueryParam = {
    monthList: [], //评价月
    category2CodeList: [], //category2Code集合
    category3CodeList: [], //category3Code集合
    groupName: "", //供应商集团名称
    facilityName: "", //facility名称
    factorType: "SENSORY", //指标类型
    status: "", //状态
    grade: "", //等级
    isExistDocument: "", //是否显示有附件的数据
    pageNum: 1,
    pageSize: 15,
};
// MSV
export let MSVQueryParam = {
    monthList: [], //评价月
    category2CodeList: [], //category2Code集合
    category3CodeList: [], //category3Code集合
    groupName: "", //供应商集团名称
    facilityName: "", //facility名称
    factorType: "MSV", //指标类型
    status: "", //状态
    grade: "", //等级
    isExistDocument: "", //是否显示有附件的数据
    pageNum: 1,
    pageSize: 15,
};
export let stockRecoveryPageQueryParam = {
    pageSize: 15,
    pageNum: 1,
    srNumber: "",
    recoveryProjectSummary: "",
    eightBitCodeName: "",
    status: "",
    facilityName: "",
};
export let fspiQueryParam = {
    status: "",
    year: "",
    quarter: "",
    month: "",
    type: "M",
    pageSize: 15,
    pageNum: 1,
};
export let QIPQueryParam = {
    pageSize: 15,
    pageNum: 1,
    monthList: [],
    qipCode: "",
    supplierName: "",
    eightBitCodeName: "",
    category2CodeList: [],
    causeOfNonconformityList: [],
    minQuantity: "",
    maxQuantity: "",
    mcdBuyingUnit: "",
    responsiblePartyList: [],
    carrierCode: "",
    feedbackResults: "",
    statusList: [],
    dcCodeList: [],
};
export let rmcProtAuditQueryParam = {
    pageSize: 15,
    pageNum: 1,
    category3Code: "",
    sponsorName: "",
    aslGroupName: "",
    auditorName: "",
    auditScope: "",
    auditorStatus: "Effective",
    auditStatus: "",
};
export let rmcProtFeedPlantQueryParam = {
    pageSize: 15,
    pageNum: 1,
    category3Code: "",
    sponsorName: "",
    aslGroupName: "",
    feedFactoryName: "",
    auditStatus: "",
    factoryStatus: "InUse",
};
export let rmcProtPurchaseQueryParam = {
    pageSize: 15,
    pageNum: 1,
    documentNo: "",
    monthFrom: "",
    monthTo: "",
    category3Code: "",
    sponsorName: "",
    status: "",
};
export let rmcProtFarmQueryParam = {
    pageSize: 15,
    pageNum: 1,
    category3Code: "",
    sponsorName: "",
    aslGroupName: "",
    farmName: "",
    isInspected: "",
    breedingMode: "",
    farmNature: "",
    farmStatus: "InUse",
    auditStatus: "",
};
export let rmcProdFarmQueryParam = {
    pageSize: 15,
    pageNum: 1,
    category3Code: "",
    sponsorName: "",
    aslGroupName: "",
    farmName: "",
    isInspected: "",
    breedingMode: "",
    farmNature: "",
    farmStatus: "InUse",
    auditStatus: "",
};
export let rmcProdAuditQueryParam = {
    pageSize: 15,
    pageNum: 1,
    category3Code: "",
    sponsorName: "",
    farmGroup: "",
    auditorName: "",
    auditorStatus: "Effective",
    auditStatus: "",
};
export let rmcProdPurchaseQueryParam = {
    pageSize: 15,
    pageNum: 1,
    documentNo: "",
    monthFrom: "",
    monthTo: "",
    category3Code: "",
    sponsorName: "",
    status: "",
};
export let griNutritionAnalysisQueryParam = {
    pageSize: 15,
    pageNum: 1,
    windowTimeList: [],
    griCode: "",
    griName: "",
    griDescription: "",
    categoryLevel2CodesList: [],
    categoryLevel3CodesList: [],
};